export function hyphenateIfDifferent(a: string, b: string) {
  return a !== b ? `${a} - ${b}` : b;
}

export function parenthesizeIfDifferent(a: string, b: string) {
  return a !== b ? `${a} (${b})` : b;
}
